import { z } from '../zod';
import { hasAtLeastOneField } from '../shared/refines';
import { OrderBumpParamsValidationSchema } from './params';
import { orderBumpSettingsInputFields } from './settings';

export const ORDER_BUMP_UPDATE_FIELDS = Object.keys(orderBumpSettingsInputFields) as ReadonlyArray<
  keyof typeof orderBumpSettingsInputFields
>;

export const UpdateOrderBumpRequestValidationSchema = z
  .object(orderBumpSettingsInputFields)
  .strict()
  .refine(hasAtLeastOneField, { message: 'At least one field must be provided.' })
  .meta({ id: 'UpdateOrderBumpRequest' });

export const UpdateOrderBumpInputValidationSchema = OrderBumpParamsValidationSchema.extend(
  orderBumpSettingsInputFields,
).refine(
  ({ pageId: _pageId, pageType: _pageType, productId: _productId, ...rest }) =>
    hasAtLeastOneField(rest),
  { message: 'At least one field must be provided.' },
);

export type UpdateOrderBumpInput = z.infer<typeof UpdateOrderBumpInputValidationSchema>;
